var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.value ? "primary" : "","disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.value ? "fa fa-check-square" : "far fa-square"))])}
var staticRenderFns = []

export { render, staticRenderFns }